import styled from '@emotion/styled';
import { Button } from '../../components/Marketing/Button';

export const Title = styled('div')({
  textAlign: 'left',
  fontSize: '16px',
  fontFamily: 'Open Sans',
  fontWeight: 'bold',
  paddingTop: '20px',
  paddingLeft: '35px',
  paddingRight: '35px',
});

export const Middle = styled(`div`)({
  display: 'flex',
  justifyContent: 'center',
  background: '#f5f5f5',
  paddingTop: '50px',
  paddingBottom: '50px',
});

export const Container = styled(`div`)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '366px',
  minHeight: '350px',
  position: 'relative',
  background: 'white',
  overflow: 'hidden',
});

export const ErrorContainer = styled(Container)({
  justifyContent: 'center',
});

export const IdpsContainer = styled(`div`)({
  width: '100%',
  paddingTop: '20px',
  paddingLeft: '35px',
  paddingRight: '35px',
});

export const ErrorBox = styled(`div`)({
  background: 'rgba(220, 42, 42, 0.1)',
  padding: '35px',
  color: '#721c24',
  border: '1px solid transparent',
  borderradius: '.25rem',
});

export const ButtonContainer = styled(`div`)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingTop: '20px',
  paddingLeft: '35px',
  paddingRight: '35px',
  position: 'absolute',
  bottom: '32px',
});

export const RedirectButton = styled(`div`)({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const StyledButton = styled(Button)({
  maxWidth: '100px',
});
